import React from 'react';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';

import {getLocale, getLangPrefix, getCleanURL} from 'l10n';

function LangButton({locale, location, className = '', children}) {
    let currentLocale = getLocale();
    let url = getLangPrefix(locale) + getCleanURL(location.pathname + location.search);

    let classes = className.split(' ');
    if (locale === currentLocale) classes.push('active');

    return <Link className={classes.join(' ')} to={url}>{children}</Link>
}

export default withRouter(LangButton);


// WEBPACK FOOTER //
// ./src/components/modals/LangButton.js